import moment from "moment";
import React, { MouseEvent } from "react";
import ReactTable, { Column, RowInfo } from "react-table";
import "react-table/react-table.css";
import { dateTime } from "src/constants/dateTime";
import { IReport } from "src/models/report";
import { IAsyncState } from "src/state/action";
import "src/style/components/table.scss";

// #region -------------- Interfaces -------------------------------------------------------------------

interface IProps {
  data: IReport[];
  reportRemoveStatus: IAsyncState<boolean>;
  reportDownloadStatus: IAsyncState<boolean>;
  onSelect(reportID: string): void;
  onPreview(reportID: string): void;
  onDownload(reportID: string): void;
  onRemove(reportID: string): void;
}

// #endregion

// #region -------------- Component -------------------------------------------------------------------

export class ReportsTable extends React.PureComponent<IProps> {
  private showErrorsSince: Date = new Date();

  public render() {
    const { data } = this.props;

    if (!data) {
      return null;
    }

    const tableData = [];

    for (const item of data) {
      tableData.push({
        reportID: item.reportID,
        title: item.title,
        createdAt:
          item.created && moment(item.created).format(dateTime.fullFormat),
        modifiedAt:
          item.modified && moment(item.modified).format(dateTime.fullFormat),
      });
    }

    const columns: Column[] = [
      {
        Header: "id",
        accessor: "reportID",
        show: false,
      },
      {
        Header: "Report title",
        accessor: "title",
      },
      // {
      //   Header: "Created date",
      //   accessor: "createdAt",
      //   maxWidth: 200,
      // },
      // {
      //   Header: "Modified date",
      //   accessor: "modifiedAt",
      //   maxWidth: 200,
      // },
      {
        id: "actions",
        Cell: this.renderActionButtonsCell,
        maxWidth: 120,
        sortable: false,
      },
    ];

    return (
      <div className="rb-table rb-reports-table">
        {this.renderAlertComponent()}

        <ReactTable
          data={tableData}
          columns={columns}
          defaultPageSize={tableData.length}
          getTrProps={(__, rowInfo: RowInfo) => ({
            onClick: () => this.onSelect(rowInfo),
          })}
          showPagination={false}
        />
      </div>
    );
  }

  private renderAlertComponent = () => {
    const { reportDownloadStatus, reportRemoveStatus } = this.props;
    const alerts = [];
    const errors = [reportDownloadStatus, reportRemoveStatus];

    errors.forEach((error) => {
      if (error && error.error && error.errorTimestamp > this.showErrorsSince) {
        alerts.push(
          <div key={error.error} className="alert alert-danger">
            {error.error}
          </div>
        );
      }
    });

    if (reportRemoveStatus && reportRemoveStatus.data) {
      alerts.push(
        <div key="reportRemoved" className="alert alert-success">
          Report has been successfully removed
        </div>
      );
    }

    return alerts;
  };

  private renderActionButtonsCell = (rowInfo: RowInfo) => {
    const reportID = rowInfo && rowInfo.original && rowInfo.original.reportID;

    return (
      <div className="rb-report-actions">
        <div onClick={(e) => this.onPreview(e, reportID)}>
          <i className="fas fa-link" />
        </div>
        <div onClick={(e) => this.onDownload(e, reportID)}>
          <i className="fas fa-download" />
        </div>
      </div>
    );
  };

  private onSelect = (rowInfo: RowInfo) => {
    const reportID = rowInfo && rowInfo.original && rowInfo.original.reportID;

    if (reportID) {
      this.props.onSelect(reportID);
    }
  };

  private onPreview = (event: MouseEvent<HTMLDivElement>, reportID: string) => {
    event.stopPropagation();
    this.props.onPreview(reportID);
  };

  private onDownload = (
    event: MouseEvent<HTMLDivElement>,
    reportID: string
  ) => {
    event.stopPropagation();
    this.props.onDownload(reportID);
  };
}

// #endregion
